export default __webpack_public_path__ + "static/media/blackcd_house-1.941a22c1.jpg";